import { render, staticRenderFns } from "./testMethod.vue?vue&type=template&id=81e2d2b6&scoped=true"
import script from "./testMethod.vue?vue&type=script&lang=js"
export * from "./testMethod.vue?vue&type=script&lang=js"
import style0 from "./testMethod.vue?vue&type=style&index=0&id=81e2d2b6&prod&scoped=true&lang=scss"
import style1 from "./testMethod.vue?vue&type=style&index=1&id=81e2d2b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e2d2b6",
  null
  
)

export default component.exports